<template>
	<div class="commonPageSty addEquipmentPage">
		<sidebar :sidebarType="sidebarType" :sidebarPath="sidebarPath"></sidebar>

		<div class="commonPageRigSty">
			<customBreadcrumb :breadcrumbs="breadcrumbs" :cacheObj="cacheObj"></customBreadcrumb>

			<div class="commonPageRigBottomSty">
				<el-form @submit.native.prevent :model="formData" ref="formDataRef" :rules="rules" inline
					label-width="68px" hide-required-asterisk class="formBloSty">
					<div class="commonPageBack marginBottom16 positionR">
						<div class="commonPageSmallTitle marginBottom16">
							基本信息
						</div>

						<div class="displayF justifyConB">
							<div class="displayF24Center flexWrap maxWidth1240">
								<el-form-item label="设备名称" prop="deviceName">
									<el-input ref="inputFocusRef" v-model="formData.deviceName" v-no-space
										placeholder="请输入" class="input224"></el-input>
								</el-form-item>

								<el-form-item label="型号" prop="deviceModel">
									<el-input v-model="formData.deviceModel" v-no-space:leading placeholder="请输入"
										class="input224"></el-input>
								</el-form-item>

								<el-form-item label="类别" prop="deviceTypeId">
									<el-select v-model="formData.deviceTypeId" placeholder="请选择" clearable
										class="input224">
										<el-option v-for="item in deviceTypeData" :key="item.id" :label="item.name"
											:value="item.id" />
									</el-select>
								</el-form-item>

								<el-form-item label="品牌" prop="deviceBrand">
									<el-input v-model="formData.deviceBrand" v-no-space:leading placeholder="请输入"
										class="input224"></el-input>
								</el-form-item>

								<el-form-item label="运行情况" prop="deviceRunState">
									<el-select v-model="formData.deviceRunState" placeholder="请选择" clearable
										class="input224">
										<el-option v-for="item in runStateData" :key="item.id" :label="item.name"
											:value="item.id" />
									</el-select>
								</el-form-item>

								<el-form-item label="使用人" prop="useUserId">
									<elCascaderCommon :optionsVal="formData.useUserId" :inputClass="'input224'"
										@clear="clearHandle" @changeCascader="changeHandle">
									</elCascaderCommon>
								</el-form-item>

								<el-form-item label="规格参数" prop="deviceParam" class="widthPercentage">
									<el-input v-model="formData.deviceParam" v-no-space:leading
										placeholder="请输入"></el-input>
								</el-form-item>
							</div>
						</div>

						<div class="displayF16Center flexWrap">
							<div v-for="(item, i) in fileList" :key="i"
								class="imgWH250 positionR marginBottom24 displayFCenter borderRadius4 selectBack overflowH">
								<div class="equipmentRemarkBloSty">
									{{getRemark(item.remark)}}
								</div>

								<div v-if="item.url"
									class="addEquipmentPageImg imgWH250 positionR borderRadius4 overflowH">
									<img :src="item.url" alt="" class="imgWH250 objectFitC cursor">

									<div class="maskBloSty">
										<commonUpload ref="commonUploadRef" :dataObj="{
											uploadData: getUploadData(i),
											paramsData,
											pageType: 'addEquipmentPageReplace'
										}" @handleSuccess="handleSuccess" @realTimeProgressPercentHandle="realTimeProgressPercentHandle">
										</commonUpload>
										<p>|</p>
										<div @click="removeImgHandle(item)">
											<img :src="initThemeImg(theme, 'icon_remove_h@2x')" alt="">
											<div>删除</div>
										</div>
									</div>
								</div>
								<!-- <el-upload v-else class="logoUploaderBig imgWH250"
									:action="defaultSettings.systemLinkApi + 'sys/file/upload/file'"
									:on-success="handleSuccess" :show-file-list="false" :data="getUploadData(i)"
									:headers="getUploadData(i)">
									<el-icon>
										<Plus class="imgWH40" />
									</el-icon>
								</el-upload> -->
								<commonUpload v-else :dataObj="{
									uploadData: getUploadData(i),
									paramsData,
									pageType: 'addEquipmentPage',
									formData: item.url
								}" @handleSuccess="handleSuccess" @realTimeProgressPercentHandle="realTimeProgressPercentHandle">
								</commonUpload>
							</div>
						</div>

						<div class="commonPageSmallTitle marginBottom16">
							购置信息
						</div>

						<div class="displayF24Center flexWrap maxWidth1240">
							<div class="headShowBloSty">
								<div class="titleBloSty">
									购置日期
								</div>

								<el-date-picker v-model="formData.buyTime" :show-now="false" type="date"
									format="YYYY-MM-DD" :editable="false" value-format="YYYY-MM-DD" class="input224"
									placeholder="请选择" />
							</div>

							<div class="headShowBloSty">
								<div class="titleBloSty">
									购置价格
								</div>

								<el-input v-model.trim="formData.buyPrice" placeholder="请输入"
									class="input224"></el-input>
							</div>

							<div class="headShowBloSty">
								<div class="titleBloSty">
									使用周期
								</div>

								<el-input v-model="formData.useCycle" v-no-space:leading placeholder="请输入"
									class="input224"></el-input>
							</div>

							<div class="headShowBloSty">
								<div class="titleBloSty">
									报废原因
								</div>

								<el-input v-model="formData.scrapCause" v-no-space:leading placeholder="请输入"
									class="input224"></el-input>
							</div>

							<div class="headShowBloSty widthPercentage marginBottom8">
								<div class="titleBloSty">
									供应商
								</div>

								<el-input v-model="formData.supplier" v-no-space:leading placeholder="请输入"></el-input>
							</div>
						</div>

						<!--  buttonBloP 20260603新增注释 -->
						<div class="buttonBlo buttonBloLeft padding0 columnGap4">
							<el-button @click="submitHandle()" type="primary" :loading="loading">
								{{getSureText(rowId ? '保存' : '新增')}}
							</el-button>

							<el-button v-if="rowId" @click="removeHandle()" type="danger">删除</el-button>

							<el-button @click="goBackCommonHandle('', cacheObj)">取消</el-button>

							<!-- 20260302 注释原按钮逻辑 -->
							<!-- :class="isGetPermission() ? '' : 'opacity05'" -->
							<!-- <div class="left" @click="submitHandle()">{{getSureText('保存')}}</div>
							<el-button v-if="rowId" @click="removeHandle()" type="danger">删除</el-button>
							<div class="rig" @click="goBackCommonHandle('', cacheObj)">取消</div> -->
						</div>
					</div>
				</el-form>
			</div>
		</div>

		<!-- 二次确认删除 -->
		<tipAdvertModal v-if="removeModalShow" text="是否删除设备信息？" tips="删除设备信息会连同关联设备申请记录以及维护维修同步删除，请谨慎操作"
			:loadingReset="loadingReset" @sureHandle="removeSure" @cancelHandle="cancel"></tipAdvertModal>
		<!-- 上传文件时 点击返回时提醒弹窗 -->
		<uploadBackTipsModal v-if="uploadTipsModalShow" :propsObj="commonModalObj" @cancelHandle="cancel()"
			@sureHandle="uploadTipsSure()"></uploadBackTipsModal>
	</div>
</template>

<script setup>
	import defaultSettings from '@/settings'
	import sidebar from '@/components/sidebar'
	import customBreadcrumb from '@/components/customBreadcrumb'
	import commonUpload from '@/components/commonUpload'
	import {
		Plus
	} from '@element-plus/icons-vue'
	import useUserStore from '@/store/modules/user.js'
	import {
		getRemark,
		getSureText,
		initThemeImg,
		setMessageQueue,
		isGetPermission,
		getParentPathName,
		goBackCommonHandle,
		getNotEditableShow,
		globalCacheSaveApi,
		globalCacheSaveWhereNowApi
	} from '@/utils/common.js'

	import {
		archivedeviceInfo,
		archivedeviceDelete,
		archivedeviceAddDevice,
		archivedevicetypeListAll,
		archivedeviceUpdateDevice
	} from '@/api/archivePage'

	const {
		proxy
	} = getCurrentInstance()

	// 主题色--默认亮色
	const theme = computed(() => {
		return useUserStore().theme
	})
	// 配置数据
	const userConfigData = computed(() => {
		return useUserStore().userConfigData
	})

	const route = useRoute()
	const router = useRouter()

	const sidebarType = 'archive'
	const sidebarPath = '/' + getParentPathName()

	const breadcrumbs = ref([{
		name: '设备登记',
		path: '',
	}])
	// , {
	// 	name: (route.query.id ? '编辑' : '新增') + '设备',
	// 	path: '',
	// }

	// 前置保存参数
	const paramsData = {
		moduleName: '档案库',
		functionName: '设备登记',
		skipParameter: '/addEquipmentPage' + window.location.search // 跳转路由参数
	}

	const formData = ref({})
	const rules = {
		deviceName: [{
			required: true,
			message: '请输入',
			trigger: ['change', 'blur']
		}],
		deviceTypeId: [{
			required: true,
			message: '请选择',
			trigger: ['change', 'blur']
		}],
		deviceRunState: [{
			required: true,
			message: '请选择',
			trigger: ['change', 'blur']
		}]
	}
	const rowId = ref(route.query.id || '')
	const deviceTypeData = ref([]) // 设备类别数据
	const fileList = ref([{
		url: '',
		remark: '0'
	}, {
		url: '',
		remark: '1'
	}, {
		url: '',
		remark: '2'
	}, {
		url: '',
		remark: '3'
	}, {
		url: '',
		remark: '4'
	}, {
		url: '',
		remark: '5'
	}])
	const runStateData = ref([{
		id: '正常运行',
		name: '正常运行'
	}, {
		id: '异常运行',
		name: '异常运行'
	}, {
		id: '故障停机',
		name: '故障停机'
	}, {
		id: '维护保养',
		name: '维护保养'
	}, {
		id: '闲置',
		name: '闲置'
	}]) // 使用情况
	const removeModalShow = ref(false)
	const cacheObj = ref(null)
	// 20260417 新增地址栏参数
	const paramsUrlData = ref(JSON.parse(JSON.stringify(window.location.pathname + window.location.search)))
	const uploadTipsModalShow = ref(false) // 上传提醒弹窗
	const fileName = ref(null) // 上传文件名称
	const progressPercent = ref(0) // 上传文件实时进度
	const commonModalObj = ref({})
	const loadingReset = ref(false) // 20260302 新增 报错时重置loading状态 报错时true/false提交时
	const loading = ref(false)

	// 获取提醒弹窗显示状态 0返回 1保存
	function getCommonModalShow(index) {
		// 上传中
		console.log(progressPercent.value, 'progressPercent.value')
		if (progressPercent.value && progressPercent.value !== 100) {
			uploadTipsModalShow.value = true
			commonModalObj.value = {
				index, // 0 返回 1保存
				progress: progressPercent.value,
				fileName: fileName.value,
				tipsTitle: '保存'
			}

			return true
		}

		return false
	}

	// 上传提醒弹窗 确定 （1保存 0返回） 此过程中不管是否上传完成 直接调用提交接口
	function uploadTipsSure() {
		// 20260304 新增 报错时重置loading状态
		loadingResetMethods(false)

		if (progressPercent.value && progressPercent.value !== 100) {
			progressPercent.value = 0
		}

		// 保存--提交
		submitHandle()
	}

	// 清除使用人
	function clearHandle() {
		let form = formData.value
		form.useUserId = ''
		form.useUserInfo = ''
		console.log('clearHandle', formData.value)
	}

	// 选择使用人
	function changeHandle(val) {
		let data = null
		const useUserId = formData.value.useUserId
		if (typeof val !== 'object') {
			data = JSON.parse(JSON.stringify(val))
		}

		formData.value.useUserId = data ? data : useUserId
		console.log('changeHandle', formData.value, val, typeof val, data)
	}

	// 点击删除
	function removeImgHandle(item) {
		fileList.value[Number(item.remark)] = {
			url: '',
			remark: item.remark
		}
	}

	// function filterMethod(value, option) {
	// 	console.log(value, option, 'value, option')
	// 	return option.label.toLowerCase().indexOf(value.toLowerCase()) !== -1;
	// }

	// 点击删除
	async function removeHandle() {
		// 非管理员 权限不足提示
		// if (!isGetPermission()) {
		// 	setMessageQueue('warning', '权限组不满足，无法操作')
		// 	return
		// }

		// 20260330 新增许可权限校验 (10设备的删除)
		const data = await getNotEditableShow('', '', 10)
		if (data.code === 505) {
			return
		}

		removeModalShow.value = true
	}

	// 删除
	function removeSure() {
		// 20260302 新增 报错时重置loading状态 报错时true/false提交时
		loadingReset.value = false

		archivedeviceDelete({
			ids: [rowId.value]
		}).then(res => {
			if (res) {
				cancel()
				setMessageQueue('success', '设备删除成功')
				localStorage.setItem('submitType', 'addAndRemoveChild')
				localStorage.setItem('removeEId', rowId.value)

				// 20260410 新增 获取设备审核中数量
				useUserStore().archivedeviceapplyApprovalNumApi()

				// 公共返回方法 // 20260608新增优化 详情进入编辑时返回2级 直接进入返回一级
				goBackCommonHandle(route.query.page ? -2 : '', cacheObj.value)
			}
		}).catch(e => {
			// 20260302 新增 报错时重置loading状态 报错时true/false提交时
			loadingReset.value = true
			setMessageQueue('error', e)
			console.log(e)
		})
	}

	function cancel() {
		removeModalShow.value = false
		uploadTipsModalShow.value = false
	}

	// 保存
	async function submitHandle() {
		// 非管理员 权限不足提示
		// if (!isGetPermission()) {
		// 	setMessageQueue('warning', '权限组不满足，无法操作')
		// 	return
		// }

		// 获取提醒弹窗显示状态 创建时调用
		if (getCommonModalShow(1)) {
			return
		}

		const data = await getNotEditableShow('', '', 1)
		if (data.code === 505) {
			return
		}

		proxy.$refs.formDataRef.validate(valid => {
			if (valid) {
				let fileIds = []
				fileList.value.map(item => {
					if (item.id) {
						fileIds.push(item.id)
					}
				})
				formData.value.fileIds = fileIds

				if (loading.value) {
					return
				}

				loading.value = true

				if (rowId.value) {
					// 编辑设备
					archivedeviceUpdateDeviceApi()
				} else {
					// 新增设备
					archivedeviceAddDeviceApi()
				}
			} else {
				// 20260304 新增 报错时重置loading状态
				loadingResetMethods(true)

				return false
			}
		})
	}

	// 新增设备
	function archivedeviceAddDeviceApi() {
		archivedeviceAddDevice(formData.value).then(res => {
			if (res) {
				localStorage.setItem('submitType', 'addAndRemoveChild')

				// 公共提示语 提交后退出当前页面逻辑
				commonCancelMsg('设备登记成功')
			}
		}).catch(e => {
			// 20260304 新增 报错时重置loading状态
			loadingResetMethods(true)
			loading.value = false
			setMessageQueue('error', e)
			console.log(e)
		})
	}

	// 编辑设备
	function archivedeviceUpdateDeviceApi() {
		archivedeviceUpdateDevice(formData.value).then(res => {
			if (res) {
				localStorage.setItem('submitType', 'editChild')

				// 公共提示语 提交后退出当前页面逻辑
				commonCancelMsg('设备保存成功')
			}
		}).catch(e => {
			// 20260304 新增 报错时重置loading状态
			loadingResetMethods(true)
			loading.value = false
			setMessageQueue('error', e)
			console.log(e)
		})
	}

	// 20260304 新增 报错时重置loading状态 报错时true/false提交时
	function loadingResetMethods(val) {
		commonModalObj.value.loadingReset = val
	}

	// 公共提示语 提交后退出当前页面逻辑
	function commonCancelMsg(msg) {
		cancel()
		loading.value = false
		setMessageQueue('success', msg)
		// 公共返回方法
		goBackCommonHandle('', cacheObj.value)
	}

	// 获取上传参数
	function getUploadData(index) {
		let params = {
			type: 'archive_device', // 类型： archive_device（档案设备）
			remark: index + '',
			token: localStorage.getItem('token')
		}
		console.log(params, 'params')
		return params
	}

	// 实时进度返回
	function realTimeProgressPercentHandle(val, name) {
		progressPercent.value = val
		fileName.value = name || ''
		commonModalObj.value.progress = val
		console.log(progressPercent.value, fileName.value, 'realTimeProgressPercentHandle')
	}

	// 上传成功
	function handleSuccess(data) {
		fileList.value[Number(data.remark)] = data
	}

	// 获取设备详情
	function getDetails() {
		archivedeviceInfo({
			id: rowId.value
		}).then(res => {
			if (res) {
				let data = res.data
				let arr = JSON.parse(JSON.stringify(fileList.value))
				formData.value = data.deviceInfo
				if (data.fileList.length > 0) {
					data.fileList.map(item => {
						arr.map((items, i) => {
							if (Number(items.remark) === Number(item.remark)) {
								fileList.value[i] = item
							}
						})
					})
				}
				console.log(fileList.value, 'fileList.value')
			}
		}).catch(e => {
			setMessageQueue('error', e)
			console.log(e)
		})
	}

	// 获取类别
	function archivedevicetypeListAllApi() {
		archivedevicetypeListAll().then(res => {
			if (res) {
				let data = res.data
				deviceTypeData.value = data
			}
		}).catch(e => {
			setMessageQueue('error', e)
			console.log(e)
		})
	}

	// 设置当前所在位置(点击菜单时删除对应的详情路径缓存数据)
	async function getGlobalCacheSaveWhereNowApi() {
		const routeData = await globalCacheSaveWhereNowApi(route.path.replace('/', ''), sidebarPath)
		console.log(routeData, 'globalCacheSaveWhereNowApi')

		if (routeData.code === 200) {
			cacheObj.value = {
				// 20260417 新增地址栏参数
				redirectPath: paramsUrlData.value,
				cacheType: 'device_log',
				level: rowId.value ? (route.query.page ? 2 : 1) : 1, // route.query.page有值 代表从详情页跳入
				queryType: '',
				queryId: rowId.value || ''
			}
			console.log(paramsUrlData.value, 'paramsUrlData.value details cacheObj.value', cacheObj.value)
			// 保存详情页路径缓存
			globalCacheSaveApi(cacheObj.value)
		}
	}

	// 监听键盘shift+enter快捷键保存
	const handleKeyDown = (e) => {
		let shortcutModelArr = userConfigData.value.shortcutModelArr

		// 20260303 新增 弹窗时禁用
		if (useUserStore().isModal) {
			return
		}

		// shift+enter快捷键保存
		if (e.shiftKey && e.key === 'Enter') {
			if (shortcutModelArr.includes(1)) {
				e.preventDefault();
				// 直接调用保存
				submitHandle()
				e.stopPropagation();
			}
		}
	};

	onBeforeUnmount(() => {
		window.removeEventListener('keydown', handleKeyDown, true);
	});

	onMounted(() => {
		if (rowId.value) {
			// 获取设备详情
			getDetails()
		}

		// 初始化当前的展开菜单
		useUserStore().sidebarType = 'archive'

		// 获取类别
		archivedevicetypeListAllApi()

		// 设置当前所在位置(点击菜单时删除对应的详情路径缓存数据)
		getGlobalCacheSaveWhereNowApi()

		setTimeout(() => {
			if (proxy.$refs.inputFocusRef) {
				proxy.$refs.inputFocusRef.focus()
			}
		}, 200)

		window.addEventListener('keydown', handleKeyDown, true);
	})
</script>

<style lang="scss" scoped>
	@import "@/styles/handle.scss";

	.formBloSty .el-form-item--default {
		margin-bottom: 16px !important;
		margin-right: 0 !important;
	}

	.commonPageRigBottomSty .commonPageBack {
		padding-bottom: 64px !important;
		min-height: calc(100vh - 116px) !important;
	}
</style>